import styled from 'styled-components';
import AppCSS from '../../../../utils/styled';
import MenuItem from '@mui/material/MenuItem';
import { DEFAULT_BUTTON_WIDTH, HEADER_BUTTON_HEIGHT } from '../../../../utils/styled/dimensions';

export const Components = {
  HeaderContainer: styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: fit-content;
    gap: 32px;
  `,
  TableWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${AppCSS.boxShadows.block};
  `,
  SearchBarChildrenWrapper: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 24px;
    margin-left: 8px;
    height: 100%;
  `,
  SearchBarSeparator: styled.div`
    width: 1px;
    height: 38px;
    background-color: ${AppCSS.colors.greys.light};
  `,
  FiltersWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: ${DEFAULT_BUTTON_WIDTH}px;
    min-width: ${DEFAULT_BUTTON_WIDTH}px;
    height: ${HEADER_BUTTON_HEIGHT}px;
    min-height: ${HEADER_BUTTON_HEIGHT}px;
  `,

  MenuItem: styled(MenuItem)`
    padding: 8px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
  `,
};
